import type { OrderDetailsOrderLine } from '@/types/orderDetailsOrder';

import { Box } from '@/components/Box';
import { EngravingCard } from '@/components/EngravingCard/EngravingCard';
import type { getEngravingDetailsFromMetadata } from '@/lib/engraving';
import { OrderLineWithdrawalCaption } from '@/views/withdrawal/components/OrderLineWithdrawalCaption';
import { getOrderLineWithdrawalCaptionModel } from '@/views/withdrawal/orderLineWithdrawalCaption';

import type { OrderDetailsContextValue } from '../orderDetailsContext.types';

import * as S from '../OrderDetailsView.styles';

export type EngravingOrderLineRowProps = Readonly<{
  engravingDetails: NonNullable<
    ReturnType<typeof getEngravingDetailsFromMetadata>
  >;
  hasFulfillment: OrderDetailsContextValue['hasFulfillment'];
  index: number;
  isOrderHistory: boolean;
  isWithdrawalEligibilityLoading: boolean;
  lineAlreadyInReturn: boolean;
  orderLine: OrderDetailsOrderLine;
  withdrawalEligibility: OrderDetailsContextValue['withdrawal']['withdrawalEligibility'];
}>;

export function EngravingOrderLineRow({
  engravingDetails,
  hasFulfillment,
  index,
  isOrderHistory,
  isWithdrawalEligibilityLoading,
  lineAlreadyInReturn,
  orderLine,
  withdrawalEligibility,
}: EngravingOrderLineRowProps) {
  const showWithdrawalCaption =
    isOrderHistory && !hasFulfillment && !lineAlreadyInReturn;

  return (
    <S.OrderLineRow
      key={orderLine.id}
      data-testid={`OrderDetailsViewOrderLineRow-${index}`}
      justifyContent='space-between'
    >
      <EngravingCard
        cardSize='small'
        data-testid={`OrderDetailsViewOrderLineEngravingCard-${index}`}
        engravingDetails={engravingDetails}
        hasBraceletSizeNotSelectedError={false}
        isMyOrder={true}
        isRelatedProduct
        lineId={orderLine.id}
        productVariant={orderLine.variant!}
      >
        {showWithdrawalCaption ? (
          <Box marginTop={1}>
            <OrderLineWithdrawalCaption
              model={getOrderLineWithdrawalCaptionModel(
                orderLine.id,
                withdrawalEligibility,
                isWithdrawalEligibilityLoading,
              )}
            />
          </Box>
        ) : null}
      </EngravingCard>
    </S.OrderLineRow>
  );
}
